<template>
    <Card class="card">
        <Spin size="large" v-if="loading"></Spin>
        <div v-else>
            <div class="title">
                <count-down ref="child" id="countdown"  :duration="paperInfo.examTime" @childFn="countSpendTime"></count-down>
                <!-- <Button type="primary" :loading="subLoading" @click="handleEndTest">交卷并查看结果</Button> -->
            </div>
            <div class="item-num">
                <span :class="[{'activeIndex':currIndex===i}]" v-for="(item,i) in paperInfo.question" :key="i" @click="toggleQuestion(i,item)">{{i+1}}</span>
            </div>
            <div class="item-detail">
                <questionSingle v-if="currItemInfo.questionType === 1" :info='currItemInfo' @childQuestionFn="pSigleFn"></questionSingle>
                <questionMultiple v-if="currItemInfo.questionType === 2" :info='currItemInfo' @childQuestionFn="pMultipleFn"></questionMultiple>
                <questionJugle v-if="currItemInfo.questionType === 3" :info='currItemInfo' @childQuestionFn="pJugleFnFn"></questionJugle>
                <div v-if="flag">
                    <questionFillBlank v-if="currItemInfo.questionType === 4" :info='currItemInfo' :answerCount="currItemInfo.answerCount*1" @childQuestionFn="pFillFn"></questionFillBlank>
                </div>
                <questionSubject v-if="currItemInfo.questionType === 5" :info='currItemInfo' @childQuestionFn="pSubjectFn"></questionSubject>
                <div v-if="currItemInfo.questionType === 6">
                    <div class="scratchIframe" style="height:700px" v-if="isShowScratch">
                        <iframe id="iframe" src="/scratch-gui/" frameBorder="0" width="100%" height="100%" scrolling="auto"></iframe>
                    </div>
                </div>
            </div>
            <div class="item-footer">
                <Button type="primary" :disabled="prevStatus" @click="prev(currQuestionId, currItemInfo.questionType)">上一题</Button>
                <Button type="primary" v-if="!nextStatus" @click="next(currQuestionId, currItemInfo.questionType)">下一题</Button>
                <Button type="primary" v-else :loading="subLoading" @click="handleEndTest">交卷并查看结果</Button>
            </div>
        </div>
        <!-- 答题结果  :mask-closable="false"-->
        <Modal v-model="showResultModal" class="resultModal" @on-cancel="offResultModal" width="800" :closable="false" :z-index='9999'>
            <Spin size="large" v-if="loading"></Spin>
            <div v-else>
                <div class="re-title">测验结果</div>
                <div class="re-counts">
                    <div v-if="paperAnswerInfo.questionAnswerList">总题数：{{ paperAnswerInfo.questionAnswerList.length }}题</div>
                    <div>已做：{{ paperAnswerInfo.doCount }}题</div>
                    <div>正确：{{ paperAnswerInfo.rightCount }}题</div>
                </div>
                <div class="re-num">
                    <span v-for="(item,i) in currInfo.count" :key="i">{{item}}</span>
                </div>
                <div class="right-rate">
                    <div>正确率</div>
                    <div>{{ paperAnswerInfo.rightRate }}</div>
                    <div>耗时：{{ paperAnswerInfo.costTime }}</div>
                </div>
                <div v-if="showResultModal">
                    <div class="item-detail" v-for="(item,i) in paperAnswerInfo.questionAnswerList" :key="i">
                        <questionSingleView v-if="item.questionType === 1" :info='item.question' :status="item.rightStatus" :yourAnswer="item.yourAnswer" :correctAnswer="item.question.answer" :txtSolution="item.question.txtSolution" :videoSolution="item.question.videoSolution"></questionSingleView>
                        <questionMultipleView v-if="item.questionType === 2" :info='item.question' :status="item.rightStatus" :yourAnswer="item.yourAnswers" :correctAnswer="item.question.answer" :txtSolution="item.question.txtSolution" :videoSolution="item.question.videoSolution"></questionMultipleView>
                        <questionJugleView v-if="item.questionType === 3" :info='item.question' :status="item.rightStatus" :yourAnswer="item.yourAnswer" :correctAnswer="item.rightAnswers" :txtSolution="item.question.txtSolution" :videoSolution="item.question.videoSolution"></questionJugleView>
                        <questionFillBlankView  v-if="item.questionType === 4" :info='item.question' :status="item.rightStatus" :correctAnswer='item.rightAnswers' :yourAnswer="item.yourAnswers" :txtSolution='item.question.txtSolution' :videoSolution='item.question.videoSolution'></questionFillBlankView>
                        <!-- <div v-if="item.questionType === 6">编程题</div> -->
                    </div>
                </div>
            </div>
        </Modal>
        <Modal v-model="tipModal" title='提示' @on-cancel="cancelExam">
            <div>您还有试卷未完成，请继续答题</div>
            <div slot="footer">
                <Button type="text" @click="cancelExam">取消</Button>
                <Button type="primary" @click='continueExam()'>确定</Button>
            </div>
        </Modal>
    </Card>
</template>
<script>
import countDown from './components/countDown.vue'

import questionSingle from './components/questionSingle.vue'
import questionSingleView from './components/questionSingleView.vue'

import questionMultiple from './components/questionMultiple.vue'
import questionMultipleView from './components/questionMultipleView.vue'

import questionJugle from './components/questionJugle.vue'
import questionJugleView from './components/questionJugleView.vue'

import questionFillBlank from './components/questionFillBlank.vue'
import questionFillBlankView from './components/questionFillBlankView.vue'

import questionSubject from './components/questionSubject.vue'
// import questionSubjectView from './components/questionSubjectView.vue'

import util from '@/libs/util'
import { parseAttr } from 'xss'
export default {
    components: { countDown, questionSingle, questionMultiple, questionJugle, questionSubject, questionFillBlank, questionSingleView, questionMultipleView, questionJugleView, questionFillBlankView  },
    data(){
        return{
            currExamPaperId: '',
            paperInfo: {},
            currQuestionId: '',
            startTime: 0,
            prevStatus: false,
            nextStatus: false,
            currIndex: 0,
            isNext: false,
            singleAnwer: '',
            multipleAnswer: '',
            jugleAnswer: '',
            fillAnswer: '',
            subjectAnswer: '',
            currInfo: {},
            paperAnswerInfo: {},
            loading: false,
            submitLoading: false,
            subLoading: false,
            showResultModal: false,

            timeSpend: 0,
            currItemInfo: {},
            userInfo:{},
            flag: false,
            ossPath: '',
            isShowScratch: false,
            corrextAnswer: '',
            tipModal: false,
            examId: '',
            summaryId: '',
            events: {
                receiveMessageFromParent: async function(event) {
                if (document.getElementById('iframe')) {
                    var ifwind = document.getElementById('iframe').contentWindow
                    switch (event.data.DYType) {
                    case 'menuOk':
                        var postData = {
                            DYType: 'opusData',
                            DYOpusData: { materialPath: this.$vue.ossPath },
                            DYShowScoreButton: false,
                            DYShowSaveButton: false,
                            DYIsDesktop: false,
                            DYFrom: 'xbz',
                            DYCanManageFiles: false,
                            DYShowSubmitButton: false
                        }
                        ifwind.postMessage(postData, '*')
                        break
                    case 'getDownToken':
                        let dirPath = event.data.DyDirPath
                        
                        const postData = {
                            DYType: 'aliStsData',
                            downLoadUrl: this.$vue.ossPath,
                            DYLoadType: event.data.DYLoadType
                        }
                        ifwind.postMessage(postData, '*')
                        break
                    case 'nextGo':
                        // console.log("做题成功");
                        this.$vue._handleSuccess()
                        break
                    }
                }
                },
                initScore: 0,
                score: 0,
                DyOssPath: '',
                showScoreButton: false,
                DYShowSaveButton: false
            },
             
        }
    },
    mounted(){
        this.userInfo = util.localGet('userInfo')
        this.currExamPaperId = this.$route.query.examPaperId
        this.summaryId = this.$route.query.summaryId
        this._generateExamPaperDetails()
        this.currInfo = this.$route.query
        this.startTime = Date.parse(new Date())
        this.prevStatus = true
        
        window['$vue'] = this
        window.addEventListener('message', this.events.receiveMessageFromParent, false)
    },
    beforeDestroy() {
        window.removeEventListener('message', this.events.receiveMessageFromParent, false)
    },
    methods:{
        
        // 试卷详情
        async _generateExamPaperDetails(){
            this.loading = true
            let params = {
                userId: this.userInfo.id,
                userName: this.userInfo.userName,
                examPaperId: this.currExamPaperId,
                summaryId: this.summaryId || ''
            }
            util.md5Encryption(params)
            const res= await this.postTKRequest('/v1/generateExamPaperDetails',params,true)
            this.loading = false
            if(res.success){
                
                if(!res.result.supplementaryStatus){
                   
                    res.result.examTime = parseInt(res.result.examTime)*60000
                    res.result.question.forEach((item)=>{
                        item.scoreValue = 0
                        item.rightStatus = '0'
                    })
                    this.paperInfo = res.result
                    this.currQuestionId = res.result.question[0].questionId
                    this._getQuestionDetails(res.result.question[0].questionId,true)
                     
                }else{ // 复考 弹框
                    this.tipModal = true
                    res.result.examTime = parseInt(res.result.examTime)*60000
                    res.result.question.forEach((item)=>{//添加得分属性，正确状态0为未做题
                        item.scoreValue = 0
                        item.rightStatus = '0'
                    })
                        
                    this.paperInfo = res.result
                    this.currQuestionId = res.result.question[0].questionId
                    return;
                }
            }
        },
        continueExam(){
            if(this.$refs.child){// 确定继续答题，开始倒计时
                this.$refs.child.init()
            }
            this.tipModal = false
            this._getQuestionDetails(this.currQuestionId)
        },
        cancelExam(){
            this.tipModal = false
            this.$router.push({ name:'simulationTest' })
        },
        // 获取试题详情
        async _getQuestionDetails(id,isShowCountdown){
            if(isShowCountdown){
                this.$nextTick(()=>{//开始计时
                    this.$refs.child.init()
                })
            }
            this.flag = false
            let params = {
                id: id,
                userId: this.userInfo.id || '',
                userName: this.userInfo.userName|| '',
            }
            util.md5Encryption(params)
            const res= await this.postTKRequest('/v1/getQuestionDetails', params, true)
            if(res.success){
                switch (res.result.questionType) {
                    case 1:
                        res.result.optionsA = decodeURIComponent(res.result.optionsA)
                        res.result.optionsB = decodeURIComponent(res.result.optionsB)
                        res.result.optionsC = decodeURIComponent(res.result.optionsC)
                        if(res.result.optionsD){
                            res.result.optionsD = decodeURIComponent(res.result.optionsD)
                        }
                        if(res.result.optionsE){
                            res.result.optionsE = decodeURIComponent(res.result.optionsE)
                        }
                        if(res.result.optionsF){
                            res.result.optionsF = decodeURIComponent(res.result.optionsF)
                        }
                        this.corrextAnswer = this.currItemInfo.answer
                    break;
                    case 2://多选
                        res.result.optionsA = decodeURIComponent(res.result.optionsA)
                        res.result.optionsB = decodeURIComponent(res.result.optionsB)
                        res.result.optionsC = decodeURIComponent(res.result.optionsC)
                        if(res.result.optionsD){
                            res.result.optionsD = decodeURIComponent(res.result.optionsD)
                        }
                        if(res.result.optionsE){
                            res.result.optionsE = decodeURIComponent(res.result.optionsE)
                        }
                        if(res.result.optionsF){
                            res.result.optionsF = decodeURIComponent(res.result.optionsF)
                        }
                        this.corrextAnswer = decodeURIComponent(res.result.answer)
                    break;
                    case 3://判断
                        if(res.result.answer=='对' || res.result.answer=='Ｔ'){
                            this.corrextAnswer = 'A'
                            res.result.rightAnswer = 'A'
                        }else if(res.result.answer=='错' || res.result.answer=='Ｆ'){
                            this.corrextAnswer = 'B'
                            res.result.rightAnswer = 'B'
                        }
                    break;
                    case 4:// t填空
                        this.flag = true
                        if(res.result.answerCount=='1'){
                            res.result.answerA = decodeURIComponent(res.result.answerA)
                            res.result.answer = res.result.answerA
                            this.corrextAnswer = res.result.answerA
                        }else if(res.result.answerCount=='2'){
                            res.result.answerA = decodeURIComponent(res.result.answerA)
                            res.result.answerB = decodeURIComponent(res.result.answerB)
                            this.corrextAnswer = res.result.answerA + '&' + res.result.answerB
                            res.result.answer = res.result.answerA + ',' + res.result.answerB
                        }else if(res.result.answerCount=='3'){
                            res.result.answerA = decodeURIComponent(res.result.answerA)
                            res.result.answerB = decodeURIComponent(res.result.answerB)
                            res.result.answerC = decodeURIComponent(res.result.answerC)
                            this.corrextAnswer = res.result.answerA + '&' + res.result.answerB + '&' + res.result.answerC
                            res.result.answer = res.result.answerA + ',' + res.result.answerB + ',' + res.result.answerC
                        }
                        else if(res.result.answerCount=='4'){
                            res.result.answerA = decodeURIComponent(res.result.answerA)
                            res.result.answerB = decodeURIComponent(res.result.answerB)
                            res.result.answerC = decodeURIComponent(res.result.answerC)
                            res.result.answerD = decodeURIComponent(res.result.answerD)
                            this.corrextAnswer = res.result.answerA + '&' + res.result.answerB + '&' + res.result.answerC + '&' + res.result.answerD
                            res.result.answer = res.result.answerA + ',' + res.result.answerB + ',' + res.result.answerC + ',' + res.result.answerD
                        }
                        else if(res.result.answerCount=='5'){
                            res.result.answerA = decodeURIComponent(res.result.answerA)
                            res.result.answerB = decodeURIComponent(res.result.answerB)
                            res.result.answerC = decodeURIComponent(res.result.answerC)
                            res.result.answerD = decodeURIComponent(res.result.answerD)
                            res.result.answerE = decodeURIComponent(res.result.answerE)
                            this.corrextAnswer = res.result.answerA + '&' + res.result.answerB + '&' + res.result.answerC + '&' + res.result.answerD + '&' + res.result.answerE
                            res.result.answer = res.result.answerA + ',' + res.result.answerB + ',' + res.result.answerC + ',' + res.result.answerD + ',' + res.result.answerE
                        }
                    break;
                    case 5://主观
                        console.log('主观题')
                        this.corrextAnswer = decodeURIComponent(res.result.answer)
                    break;
                    case 6:// 程序
                        if (res.result.programmingType === 1 || 0) {
                            this.ossPath = res.result.programmingPath
                            this.isShowScratch = true
                        } 
                    break
                }
                res.result.title = decodeURIComponent(res.result.title)
                this.currItemInfo = res.result
                let index = this.paperInfo.question.findIndex((value, index, arr) => {
                    return value.questionId === id
                })
                if(this.paperInfo.question[index].yourAnswer){
                    this.currItemInfo.yourAnswer = this.paperInfo.question[index].yourAnswer
                }
                // console.log(this.currItemInfo,'this.currItemInfo')
                // this.paperInfo.question[index].rightAnswer = this.currItemInfo.answer
                
            }
        },
        toggleQuestion(index,item){
            this.startTime = Date.parse(new Date())
            this.currIndex = index
            this.currQuestionId = item.questionId
            if(index > 0 ){
                this.prevStatus = false
            }else{
                this.prevStatus = true
            }
            if(index > this.paperInfo.question.length-2){
                this.nextStatus = true
            }else{
                this.nextStatus = false
            }
            this._getQuestionDetails(this.currQuestionId)
        },
        prev(id, type){
            this.nextStatus = false
            let index = this.paperInfo.question.findIndex((value, index, arr) => {
                return value.questionId === id
            })
            if(index>0){
                this.currIndex = parseInt(index - 1)
                if( this.paperInfo.question[index-1]){
                    this.currQuestionId = this.paperInfo.question[index-1].questionId
                    this._getQuestionDetails(this.currQuestionId)
                }
            }
            if(!this.paperInfo.question[index-2]) {
                this.prevStatus = true
            }
        },
        next(id, type){
            if(type == 4){// 填空题
                if(this.currItemInfo.yourAnswer && this.currItemInfo.yourAnswer.length !== Number(this.currItemInfo.answerCount)){
                    this.$Message.error('答案与规定答案数量不一致')
                    
                    return false
                }
            }
            this.isNext = true
            // this.submit(id, type)
            this.prevStatus = false
            let index = this.paperInfo.question.findIndex((value, index, arr) => {
                return value.questionId === id
            })
            if(!this.paperInfo.question[index].yourAnswer){//未答题分数为0
                this.paperInfo.question[index].rightStatus = '0'
                this.paperInfo.question[index].scoreValue = 0
            }
            this.currIndex = parseInt(index + 1)
            if( this.paperInfo.question[index+1]){
                this.currQuestionId = this.paperInfo.question[index+1].questionId
                this._getQuestionDetails(this.currQuestionId)
            }
            if(!this.paperInfo.question[index+2]) {
                this.nextStatus = true
            }
        },
        sum(arr) {
            var total = 0;
            if(!arr.length) return
            for (var i = arr.length-1; i>=0; i--) {
                if( arr[i] ){
                    total += arr[i];
                }
            }
            return total;
        },
        // 提交试卷查看结果
        async handleEndTest(){
            this.subLoading = true
            this.$refs.child.endCount()
            let paramArr = JSON.parse(JSON.stringify(this.paperInfo.question))
            
            let signle = []
            let multiple = []
            let judgle = []
            let fill = []
            let subject = []
            let program = []
            let totalScore = []
            paramArr.forEach(item => {
                delete item.title
                delete item.knowledgePointId
                delete item.questionNO
                delete item.score
                delete item.rightAnswer
                delete item.difficulty
                delete item.questionId
                delete item.examPaperQuestionId
                if(item.yourAnswer && typeof item.yourAnswer!=='string'){
                    item.yourAnswer = item.yourAnswer.join(',')
                }
                totalScore.push(item.scoreValue)
                switch(item.questionType){
                    case 1:
                        signle.push(item.scoreValue)
                    break;
                    case 2:
                        multiple.push(item.scoreValue)
                    break;
                    case 3:
                        judgle.push(item.scoreValue)
                    break;
                    case 4:
                        fill.push(item.scoreValue)
                    break;
                    case 5:
                        subject.push(item.scoreValue)
                    break;
                    case 6:
                        program.push(item.scoreValue)
                    break;
                }

            })
            let params = 
                {
                    examPaperName: this.paperInfo.examPaperName,
                    subjectId: this.paperInfo.subjectId,
                    examPaperParticipateSummaryId: this.paperInfo.examPaperParticipateSummaryId,
                    userId: this.userInfo.id,
                    userName: this.userInfo.userName,
                    costTime: this.timeSpend,
                    totalScore: this.sum(totalScore),
                    multipleChoiceScore: this.sum(signle) || 0,
                    multipleSelectionScore: this.sum(multiple) || 0,
                    trueFalseScore: this.sum(judgle) || 0,
                    fillsScore: this.sum(fill) || 0,
                    essayScore: this.sum(subject) || 0,
                    programmingScore: this.sum(program) || 0,
                    questionAnswerList: paramArr
            }
            // console.log(params,this.userInfo)
            const res = await this.postRequestApplication('/v1/saveExamPaperAnswer', {}, params)
            this.subLoading = false
            if(res.success){
            // //     this.startTime = Date.parse(new Date())
                this.$Message.success('提交成功')
                this.showResultModal = true
                this._getExamPaperAnswer(res.result)
            }
            
        },
        async _getPaperDetail(id){
            let params = {
                id: id,
                userId: this.userInfo.id,
                userName: this.userInfo.userName,
            }
            util.md5Encryption(params)
            const res= await this.postTKRequest('/v1/getQuestionDetails', params, true)
        },
        // 答案详情
        async _getExamPaperAnswer(id){
            this.loading = true
            let params = {
                examPaperParticipateSummaryId: id,
                userId: this.userInfo.id,
            }
            util.md5Encryption(params)
            const res = await this.postTKRequest('/v1/getExamPaperAnswer',params,true)
            this.loading = false
            if(res.success){
                let rightCount = res.result.questionAnswerList.filter((item)=>{
                    return item.rightStatus == 1
                })
                let noDoCount = res.result.questionAnswerList.filter((item)=>{
                    return item.rightStatus == 0
                })
                let doCount = res.result.questionAnswerList.length - noDoCount.length
                let rightRate = (rightCount.length / res.result.questionAnswerList.length)*100 + '%'
                res.result.questionAnswerList.forEach(item => {
                    item.question.title = decodeURIComponent(item.question.title)
                    switch (item.questionType) {
                        case 1:
                            item.question.optionsA = decodeURIComponent(item.question.optionsA)
                            item.question.optionsB = decodeURIComponent(item.question.optionsB)
                            item.question.optionsC = decodeURIComponent(item.question.optionsC)
                            if(item.question.optionsD){
                                item.question.optionsD = decodeURIComponent(item.question.optionsD)
                            }
                            if(item.question.optionsE){
                                item.question.optionsE = decodeURIComponent(item.question.optionsE)
                            }
                            if(item.question.optionsF){
                                item.question.optionsF = decodeURIComponent(item.question.optionsF)
                            }
                        break;
                        case 2:
                            item.question.optionsA = decodeURIComponent(item.question.optionsA)
                            item.question.optionsB = decodeURIComponent(item.question.optionsB)
                            item.question.optionsC = decodeURIComponent(item.question.optionsC)
                            if(item.question.optionsD){
                                item.question.optionsD = decodeURIComponent(item.question.optionsD)
                            }
                            if(item.question.optionsE){
                                item.question.optionsE = decodeURIComponent(item.question.optionsE)
                            }
                            if(item.question.optionsF){
                                item.question.optionsF = decodeURIComponent(item.question.optionsF)
                            }
                            if(item.yourAnswer){
                                item.yourAnswers = item.yourAnswer.split(',')
                            }
                        break;
                        case 3:
                            if(item.question.answer=='对'){
                                item.rightAnswers = 'A'
                            }else if(item.question.answer=='错'){
                                item.rightAnswers = 'B'
                            }
                            break;
                        case 4:// 填空题
                            if(item.yourAnswer){
                                item.yourAnswers = item.yourAnswer.split(',')
                            }
                            if(item.question.answerCount == '1' && item.rightAnswers){
                                item.rightAnswers = decodeURIComponent(item.question.answerA).split(',')
                                
                            }else if(item.question.answerCount == '2'){
                                item.question.answerA = decodeURIComponent(item.question.answerA)
                                item.question.answerB = decodeURIComponent(item.question.answerB)
                                item.rightAnswers = (item.question.answerA +','+item.question.answerB).split(',')
                            }else if(item.question.answerCount == '3'){
                                item.question.answerA = decodeURIComponent(item.question.answerA)
                                item.question.answerB = decodeURIComponent(item.question.answerB)
                                item.question.answerC = decodeURIComponent(item.question.answerC)
                                item.rightAnswers = (item.question.answerA +','+item.question.answerB +','+ item.question.answerC).split(',')
                            }else if(item.question.answerCount == '4'){
                                item.question.answerA = decodeURIComponent(item.question.answerA)
                                item.question.answerB = decodeURIComponent(item.question.answerB)
                                item.question.answerC = decodeURIComponent(item.question.answerC)
                                item.question.answerD = decodeURIComponent(item.question.answerD)
                                item.rightAnswers = (item.question.answerA +','+item.question.answerB +','+ item.question.answerC+','+ item.question.answerD).split(',')
                            }else if(item.question.answerCount == '5'){
                                item.question.answerA = decodeURIComponent(item.question.answerA)
                                item.question.answerB = decodeURIComponent(item.question.answerB)
                                item.question.answerC = decodeURIComponent(item.question.answerC)
                                item.question.answerD = decodeURIComponent(item.question.answerD)
                                item.question.answerE = decodeURIComponent(item.question.answerE)
                                item.rightAnswers = (item.question.answerA +','+item.question.answerB +','+ item.question.answerC+','+ item.question.answerD+','+ item.question.answerE).split(',')
                            }
                            item.yourAnswer = item.yourAnswer ? item.yourAnswer.split(',') : []
                        break;
                    }
                    
                })
                
                this.paperAnswerInfo = res.result
                this.paperAnswerInfo.rightCount = rightCount.length
                this.paperAnswerInfo.doCount = doCount
                this.paperAnswerInfo.rightRate = rightRate
            }
        },
        pSigleFn(data){
            let index = this.paperInfo.question.findIndex((value, index, arr) => {
                return value.questionId === data.questionId
            })
            this.paperInfo.question[index].yourAnswer = data.answer
            this.paperInfo.question[index].rightStatus = (data.answer == this.paperInfo.question[index].answer ? 1 : -1)
            this.paperInfo.question[index].scoreValue = this.paperInfo.question[index].rightStatus==1 ? this.paperInfo.question[index].score : 0
            this.singleAnwer = data
        },
        pMultipleFn(data){
            let index = this.paperInfo.question.findIndex((value, index, arr) => {
                return value.questionId === data.questionId
            })
            this.paperInfo.question[index].yourAnswer = data.answer.sort()
            this.paperInfo.question[index].rightStatus = data.answer == this.paperInfo.question[index].answer ? 1 : -1
            this.paperInfo.question[index].scoreValue = this.paperInfo.question[index].rightStatus==1 ? this.paperInfo.question[index].score : 0
            this.multipleAnswer = data
        },
        pJugleFnFn(data){
            let index = this.paperInfo.question.findIndex((value, index, arr) => {
                return value.questionId === data.questionId
            })
            this.paperInfo.question[index].yourAnswer = data.answer
            this.paperInfo.question[index].rightStatus = data.answer == this.corrextAnswer ? 1 : -1
            this.jugleAnswer = data
            this.paperInfo.question[index].scoreValue = this.paperInfo.question[index].rightStatus==1 ? this.paperInfo.question[index].score : 0
        },
        pSubjectFn(data){
            let index = this.paperInfo.question.findIndex((value, index, arr) => {
                return value.questionId  === data.questionId
            })
            this.paperInfo.question[index].yourAnswer = data.answer
            this.paperInfo.question[index].rightStatus = data.answer == this.corrextAnswer ? 1 : -1
            
            this.subjectAnswer = data
        },
        pFillFn(data){
            let index = this.paperInfo.question.findIndex((value, index, arr) => {
                return value.questionId === data.questionId
            })
            let fillData = this.paperInfo.question[index]
            let rightData = []
            fillData.yourAnswer = data.answer
            this.currItemInfo.yourAnswer = data.answer
            switch (data.anserCount) {
                case 1:
                    fillData.answerA = decodeURIComponent(fillData.answerA)
                    fillData.rightStatus = data.answer.join(',').trim() == fillData.answerA ? 1 : -1
                    rightData.push(fillData.answerA)
                    fillData.rightAnswers = rightData
                    break;
                case 2:
                    fillData.answerA = decodeURIComponent(fillData.answerA)
                    fillData.answerB = decodeURIComponent(fillData.answerB)
                    rightData = []
                    fillData.rightStatus = (data.answer[0].trim() == fillData.answerA && data.answer[1] && data.answer[1].trim() ==fillData.answerB) ? 1 : -1
                    rightData.push(fillData.answerA,fillData.answerB)
                    fillData.rightAnswers = rightData
                    break;
                case 3:
                    fillData.answerA = decodeURIComponent(fillData.answerA)
                    fillData.answerB = decodeURIComponent(fillData.answerB)
                    fillData.answerC = decodeURIComponent(fillData.answerC)
                    fillData.rightStatus = (data.answer[0].trim() == fillData.answerA && data.answer[1] && data.answer[1].trim() ==fillData.answerB  && data.answer[2] && data.answer[2].trim() ==fillData.answerC) ? 1 : -1
                    rightData.push(fillData.answerA, fillData.answerB, fillData.answerC)
                    fillData.rightAnswers = rightData
                    break;
                case 4:
                    fillData.answerA = decodeURIComponent(fillData.answerA)
                    fillData.answerB = decodeURIComponent(fillData.answerB)
                    fillData.answerC = decodeURIComponent(fillData.answerC)
                    fillData.answerD = decodeURIComponent(fillData.answerD)
                    fillData.rightStatus = (data.answer[0].trim() == fillData.answerA && data.answer[1] && data.answer[1].trim() ==fillData.answerB  && data.answer[2] && data.answer[2].trim() ==fillData.answerC  && data.answer[3] && data.answer[3].trim() ==fillData.answerD) ? 1 : -1
                    rightData.push(fillData.answerA, fillData.answerB, fillData.answerC, fillData.answerD)
                    fillData.rightAnswers = rightData
                    break;
                case 5:
                    fillData.answerA = decodeURIComponent(fillData.answerA)
                    fillData.answerB = decodeURIComponent(fillData.answerB)
                    fillData.answerC = decodeURIComponent(fillData.answerC)
                    fillData.answerD = decodeURIComponent(fillData.answerD)
                    fillData.answerE = decodeURIComponent(fillData.answerE)
                    fillData.rightStatus = (data.answer[0].trim() == fillData.answerA && data.answer[1] && data.answer[1].trim() ==fillData.answerB  && data.answer[2] && data.answer[2].trim() ==fillData.answerC  && data.answer[3] && data.answer[3].trim() ==fillData.answerD  && data.answer[4] && data.answer[4].trim() ==fillData.answerE) ? 1 : -1
                    rightData.push(fillData.answerA, fillData.answerB, fillData.answerC, fillData.answerD, fillData.answerE)
                    fillData.rightAnswers = rightData
                    break;
                
            }
            this.paperInfo.question[index].scoreValue = this.paperInfo.question[index].rightStatus==1 ? this.paperInfo.question[index].score : 0
            this.yourAnswer = data
        },
        countSpendTime(childTimeInfo){
            this.timeSpend = childTimeInfo
            // this.modalShow = false
            
        },
        // 查看知识点解析
        viewKnowledgeResolution(item){
            this.resolveModal = true
            this.currInfo = item
        },
        offResultModal(){
            this.showResultModal = false
            this.$router.push({name:'simulationTest'})
        },
    }
}
</script>
<style lang="less" scoped>
.card{
    /deep/ .ivu-card-body{
        min-height: 600px;
        .item-footer{
            position: absolute;
            bottom: 20px;
            left: 0;
        }
    }
}
.item-detail{
    margin-top: 30px;
}
.activeIndex{
    color: #fff;
    background: #FCB538;
}
.resultModal{
    /deep/ .ivu-modal-footer{
        display: none;
    }
    .re-title{
        width: 100%;
        text-align: center;
        font-weight: 700;
        font-size: 20px;
    }
    .re-counts{
        width: 400px;
        display: flex;
        justify-content: space-between;
        height: 70px;
        align-items: center;
    }
    .re-num{
        span{
            padding: 5px 10px;
            margin-right: 10px;
            border-radius: 4px;
            border: 1px solid #eee;
            cursor: pointer;
        }
    }
    .right-rate{
        position: absolute;
        top: 0;
        right: 0;
        padding: 10px 20px;
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #FF9D00;
        color: #fff;
        border-radius:0 6px 0 6px;
        font-size: 12px;
        div:nth-child(2){
            font-size: 26px;
        }
    }
    .re-spend{
        margin: 20px 0;
    }
}
.title{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 70px;
    padding: 0 30px;
    div:first-child{
        position: absolute;
        top: 30px;
        left: 50%;
        transform: translateX(-50%);
    }
    /deep/ .ivu-btn{
        background-color: #FF9D00;
        color: #fff;
        border: none;
        outline: none;
    }
}
.item-num{
    margin-top: 20px;
    span{
        padding: 5px 10px;
        border-radius: 4px;
        margin-right: 10px;
        border: 1px solid #eee;
        // box-shadow: 2px 2px 2px rgba(0,0,0,.3);
        cursor: pointer;
    }
}
.item-footer{
    width: 17%;
    display: flex;
    margin-left: 60px;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    /deep/ .ivu-btn{
        background-color: #FF9D00;
        color: #fff;
        border: none;
        outline: none;
    }
}
/deep/ .ivu-spin{
    height: 400px;
    .ivu-spin-main{
        height: 100%;
        display: inline-flex;
        align-items: center;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/practise/simulationTestDetail.vue